var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame"},[_c('div',{staticClass:"frame_head"},[_vm._t("head")],2),_c('div',{staticClass:"frame_main"},[_vm._t("main")],2),_c('div',{staticClass:"frame_foot"},[_vm._t("foot")],2),_vm._t("expand"),_c('GT'),_c('Assets')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }